import { ComponentRef, Injectable, OnDestroy } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { ApplicationService } from '../utilities/application/application.service';
import { ConditionService } from '../form-core/condition/condition.service';
import { DataService } from '../form-core/data/data.service';
import { ComponentModel } from '../form-json.types';
import { State } from '../store';
import { selectStatus } from '../store/status';
import { ProgressComponent } from './progress.component';
import { ProgressModule } from './progress.module';

@Injectable({
  providedIn: ProgressModule
})
export class ProgressService implements OnDestroy {

  private progressComponent: ComponentRef<ProgressComponent> | undefined
  private presences: { [key: string]: ComponentModel } = {}

  constructor(private app: ApplicationService, private store: Store<State>, private data: DataService, private condition: ConditionService) { }

  ngOnDestroy(): void {
    this.destroy()
  }

  create() {
    this.progressComponent = this.app.attach(ProgressComponent, document.body)
    for (let id in this.data.model['text-component']) {
      const model = this.data.model['text-component'][id]
      if (model.relationships.presences?.data?.length) this.presences[model.attributes.path] = model
    }
    this.progressComponent.instance.progress$ = this.store.pipe(
      select(selectStatus),
      map(status => {
        let total: number = 0
        let valid: number = 0
        for (let control in status) {
          if (!this.presences[control] || this.presences[control].relationships.presences?.data?.every(value => this.condition.assign(value))) {
            total++
            if (status[control] === 'DISABLED' || status[control] === 'VALID') valid++
          }
        }
        return valid / total
      }),
      distinctUntilChanged()
    )
  }

  destroy() {
    if (this.progressComponent) this.app.destroy(this.progressComponent)
  }
}
